import $ from 'jquery';
import adTagBuilder from './jwplayer-ads-homepage';
import Autoplay from './jwplayer-homepage-autoplay';

class JWPlayerInit {
    constructor() {
        this.adTag = adTagBuilder.adUrl;
        this.player = {};
        this.options = {
            playlist: '//content.jwplatform.com/feeds/DCmFDcAw.rss',
            advertising: {
                client: 'googima',
                tag: this.adTag
            },
            ga: {}, // for prod
            skin: {
                name: 'fc-custom'
            },
            mute: true //,
            // sharing: {
            //     code: encodeURI('<iframe width="720" height="415" src="//www.fastcompany.com/embed/MEDIAID?rel=1&src=embed&veggiemode=1" frameborder="0" scrolling="no" allowfullscreen></iframe>')
            //     // link: parent ? parent.document.URL : 'http://www.fastcompany.com/embed/MEDIAID'
            // }
        };
    }

    initPlayer() {
        this.player.setup(this.options);

        this.player.on('ready', function () {
            var autoplay = new Autoplay(this.player);
            autoplay.on();
        }.bind(this));
    }

    on() {
        $.getScript('//content.jwplatform.com/libraries/76APbejE.js', function () {
            this.player = jwplayer('homepage-jwplayer');
            this.initPlayer();
        }.bind(this));
    }

    off() {
        this.player = {};
    }
}

export default new JWPlayerInit();
